import { inject } from '@angular/core';
import { ResolveFn, ActivatedRouteSnapshot } from '@angular/router';

import { UserInfo } from '../../shared/models/user-info';
import { UserService } from '../../shared/services/user.service';

export const userResolver: ResolveFn<UserInfo> = (route: ActivatedRouteSnapshot) => {
	const userService = inject(UserService);
	const params = <{ id?: string }> route.params;
	const userIdParam = params['id'];
	return userService.getUserDetailsById(userIdParam || String(userService.user.id), [
		'id',
		'firstName',
		'lastName',
		'language',
		'username',
		'address.email',
		'address.phoneNumber',
		'address.phoneNumber2',
		'address.requestedMail',
		'personMembers.member',
		'personMembers.role',
		'personMembers.status',
		'lastMember',
		'lastConnectionDate',
		'creationDate',
		'timeFormat',
		'dateFormat',
		'status',
		'userType'
	]);
};
